"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListingStatus = exports.splitNameAndExtension = exports.filteredExtensions = exports.UPLOAD_TYPES = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _filteredExtensions;

var UPLOAD_TYPES = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO'
};
exports.UPLOAD_TYPES = UPLOAD_TYPES;
var filteredExtensions = (_filteredExtensions = {}, (0, _defineProperty2.default)(_filteredExtensions, UPLOAD_TYPES.IMAGE, ['jpg', 'jpeg', 'png']), (0, _defineProperty2.default)(_filteredExtensions, UPLOAD_TYPES.VIDEO, ['mp4', 'webm']), _filteredExtensions); // Copied over from FileManagerUI https://git.hubteam.com/HubSpot/FileManagerUI/blob/master/FileManagerCore/static/js/utils/file.js#L35

exports.filteredExtensions = filteredExtensions;

var splitNameAndExtension = function splitNameAndExtension(file) {
  var name = file.name;
  /* eslint-disable no-useless-escape */

  var matches = name.match(/(.*)\.([^\.]+)$/);
  /* eslint-enable no-useless-escape */

  if (!matches) {
    return {
      extension: '',
      name: name
    };
  }

  return {
    name: matches[1],
    extension: matches[2].toLowerCase()
  };
};

exports.splitNameAndExtension = splitNameAndExtension;
var ListingStatus = {
  DRAFT: 'DRAFT',
  IN_REVIEW: 'IN_REVIEW',
  LISTED: 'LISTED',
  CERTIFIED: 'CERTIFIED'
};
exports.ListingStatus = ListingStatus;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/Listings.js
// module id = 758
// module chunks = 209 210 211 212